import { Route, Switch, Redirect, useLocation } from "wouter";

import { Header } from "./components/Header/Header";
import { Footer } from "./components/Footer/Footer";
import { Home } from "./pages/Home";
import { ComoFunciona } from "./pages/ComoFunciona";
import { Tiendas } from "./pages/Tiendas";
import { ParaComercios } from "./pages/ParaComercios";
import { Ayuda } from "./pages/Ayuda";
import { Pagos } from "./pages/Pagos";
import { Web } from "./pages/Web";
import { Agentes } from "./pages/Agentes";
import { PagosTiendas } from "./pages/PagosTiendas";
import { TerminosCondiciones } from "./pages/TerminosCondiciones";
import { PoliticaPrivacidad } from "./pages/PoliticaPrivacidad";
import { TasasIntereses } from "./pages/TasasIntereses";
import { LibroReclamaciones } from "./pages/LibroReclamaciones";
import { AcercaDeMisCuotas } from "./pages/AcercaDeMisCuotas";
import { TratamientoDeDatos } from "./pages/TratamientoDeDatos";
import { FinanciaTuMoto } from "./pages/FinanciaTuMoto";
import { Wahtsap } from "./components/Wahtsap/Wahtsap";
import { MiCuentaLogin, MiCuentaAcceso } from "./pages/MiCuentaLogin";
// import { PagoYapePopup } from "./components/PagoYapePopup/PagoYapePopup"; // Pop-up oculto temporalmente

function App() {
  const [location] = useLocation();

  const validPaths = [
    "/",
    "/comoFunciona",
    "/dondeComprar",
    "/paraComercios",
    "/ayuda",
    "/pagos",
    "/web",
    "/agentes",
    "/tiendas",
    "/terminos-y-condiciones",
    "/politicaPrivacidad",
    "/tasas-y-intereses",
    "/libro-de-reclamaciones",
    "/acerca-de-mis-cuotas",
    "/tratamiento-de-datos",
    "/micuenta",
    "/pagar",
    "/financia-tu-moto"
  ];

  if (!validPaths.includes(location)) {
    return <Redirect to="/" />;
  }

  return (
    <>
      <Header />
      <Switch>
        <Route path="/" component={Home} />
        <Route path="/comoFunciona" component={ComoFunciona} />
        <Route path="/dondeComprar" component={Tiendas} />
        <Route path="/paraComercios" component={ParaComercios} />
        <Route path="/ayuda" component={Ayuda} />
        <Route path="/pagos" component={Pagos} />
        <Route path="/web" component={Web} />
        <Route path="/agentes" component={Agentes} />
        <Route path="/tiendas" component={PagosTiendas} />
        <Route path="/terminos-y-condiciones" component={TerminosCondiciones} />
        <Route path="/politicaPrivacidad" component={PoliticaPrivacidad} />
        <Route path="/tasas-y-intereses" component={TasasIntereses} />
        <Route path="/libro-de-reclamaciones" component={LibroReclamaciones} />
        <Route path="/acerca-de-mis-cuotas" component={AcercaDeMisCuotas} />
        <Route path="/tratamiento-de-datos" component={TratamientoDeDatos} />
        <Route path="/micuenta" component={MiCuentaLogin} />
        <Route path="/pagar" component={MiCuentaAcceso} />
        <Route path="/financia-tu-moto" component={FinanciaTuMoto} />
      </Switch>
      <Wahtsap />
      {/* {location !== "/financia-tu-moto" && <PagoYapePopup />} */} {/* Pop-up oculto temporalmente */}
      <Footer />
    </>
  );
}

export default App;